import { getID } from "src/libs/utilities";
import { ALIGN, LANDING_TYPE_CONTENT, LINKS_DESIGN_TYPE } from "../interfaces";
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";
import { SCALAR_TYPES } from "src/libs/scalars";

export default function contact_form(): any[] {
    return [
        {
          "type": LANDING_TYPE_CONTENT.CONTACT_FORM,
           id: getID("contact-form"),
          "vertical_align": ALIGN.FULL,
          "border_radius": 0,
          "gap": 0,
          isVerticalTitles: true,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "sendButton": {
            "rightIcon": "fas fa-arrow-right"
          },
          "thumbnail": "https://i.pinimg.com/736x/7f/44/01/7f44011010fc1c29ef733d295f402f90.jpg",
          "fields": {
            "0": {
              "field": getID("cf-1"),
              "type": "media",
              "title": "Загрузите картинку",
              "required": false
            },
            "1": {
              "field": getID("cf-2"),
              "type": "html",
              "title": "Сообщите своё сообщение",
              "required": true
            },
            "2": {
              "field": getID("cf-3"),
              "type": "date",
              "title": "Укажите удобное для Вас время"
            },
            "3": {
              "field": getID("cf-4"),
              "type": "boolean",
              "title": "Позвонить Вам?"
            }
          },
          "style": {
            "padding": 0,
            "border": "1px solid var(--force-mini-contrast-color)"
          },
            "defaultTitle": "Контактная форма с иллюстрацией"
        },
        {
          "type": LANDING_TYPE_CONTENT.CONTACT_FORM,
           id: getID("contact-form"),
          "vertical_align": ALIGN.FULL,
          "border_radius": 0,
          "gap": 0,
          "sendButton": {
            "rightIcon": "fas fa-arrow-right"
          },
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "fields": {
            "0": {
              "field": getID("cf-1"),
              "type": "media",
              "title": "Загрузите картинку",
              "required": false
            },
            "1": {
              "field": getID("cf-2"),
              "type": "html",
              "title": "Сообщите своё сообщение",
              "required": true
            },
            "2": {
              "field": getID("cf-3"),
              "type": "date",
              "title": "Укажите удобное для Вас время"
            },
            "3": {
              "field": getID("cf-4"),
              "type": "boolean",
              "title": "Позвонить Вам?"
            }
          },
          "style": {
            "padding": 0,
            "border": "1px solid var(--force-mini-contrast-color)"
          },
            "defaultTitle": "Мнинималистическая контактная форма."
        },
        {
          "type": LANDING_TYPE_CONTENT.CONTACT_FORM,
          id: getID("contact-form"),
          "vertical_align": ALIGN.FULL,
          "border_radius": 0,
          "gap": 0,
          "sendButton": { "rightIcon": "fas fa-arrow-right" },
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "isVerticalTitles": true,
          "fields": {
            "0": {
              "field": getID("cf-field"),
              "type": SCALAR_TYPES.STRING,
              "subtitle": "Представьтесь пожалуйста"
            },
            "1": {
              "field": getID("cf-field"),
              "type": SCALAR_TYPES.HTML,
              "subtitle": "Сообщите своё сообщение" 
            }
          },
          "style": {
            "padding": 40,
            "backgroundColor": "var(--force-plain-color)",
            "border": "1px solid var(--force-contrast-opacity-color)",
            "backdropFilter": "blur(9px)" 
          },
          "position": {
            "top": 0,
            "left": 0,
            "width": "100%",
            "height": "100%",
            "opacity": 1,
            "scale": 1,
            "rotate": 0,
            "style": {},
            "className": "",
            "data": {}
          },
          "defaultTitle": "Симпатичная форма с кортрастным фоном"
        },
        {
          "type": LANDING_TYPE_CONTENT.CONTACT_FORM,
          id: getID("contact-form"),
          "vertical_align": ALIGN.FULL,
          "border_radius": 0,
          "gap": 0,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "isVerticalTitles": true,
          "fields": {
            "1": {
              "field": getID("cf-field"),
              "type": SCALAR_TYPES.STRING,
              "subtitle": "Что-нибудь скажите"
            },
            "2": {
              "field": getID("cf-field"),
              "type": SCALAR_TYPES.STRING,
              "subtitle": "Ещё что-нибудь скажите"
            }
          },
          "sendButton": {
            "label": "Yes, I want to access the free lesson",
            "rightIcon": "fas fa-arrow-right",
            "design_type": LINKS_DESIGN_TYPE.SQUARE,
            "button_color": "var(--red)",
            "width": "100%", 
          },
          "style": {
            "padding": 40,
            "backgroundColor": "var(--force-plain-color)",
            "boxShadow": "rgba(0, 0, 0, .85) 0px 12px 15px 0px"
          },
          "defaultTitle": "Карточка с текстовой формой на фоне изображении"
        },
        {
          "type": LANDING_TYPE_CONTENT.CONTACT_FORM,
          id: getID("contact-form"),
          "vertical_align": ALIGN.FULL,
          "border_radius": 0,
          "gap": 0,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "isVerticalTitles": true, 
          "text_color": "#ffffff",
          "fields": {
            "1": {
              "field": getID("cf-field"),
              "type": "string",
              "notClear": true,
              "className": " form-control ",
              "subtitle": "Укажите свой адрес электронной почты"
            }
          },
          "sendButton": {
            "label": "Хочу получить доступ к бесплатному уроку.",
            "rightIcon": "fas fa-arrow-right",
            "design_type": "square",
            "button_color": "var(--red)",
            "width": "100%",
            className: "w-100",
          },
          "style": {
            "paddingBottom": 40,
            "paddingLeft": 40,
            "paddingRight": 40,
            "backgroundColor": "var(--gray-dark)",
            "backgroundImage": "url(https://i.pinimg.com/736x/c7/a5/60/c7a56048261691ab65ee1111b45bac42.jpg)",
            "backgroundSize": "cover",
            "backgroundPositionY": -146,
            "color": "var(--force-contast-color)",
            "boxShadow": "rgba(0, 0, 0, .75) 0px 16px 13px 0px"
          },
          "title": "Курс «Аналитик данных»",
          "description": "Станьте аналитиком данных за 7 месяцев с нуля. Будете много практиковаться и получите реальный опыт. Попробуйте одно занятие и узнайте, подходят ли вам профессия и формат обучения.",
          "defaultTitle": "Тёмная минималистическая форма"
        },
        {
          "type": LANDING_TYPE_CONTENT.CONTACT_FORM,
          id: getID("contact-form"),
          "vertical_align": ALIGN.FULL,
          "border_radius": 0,
          "gap": 0,
          "sendButton": { "rightIcon": "fas fa-arrow-right" },
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "fields": {
            "0": {
              "field": getID("cf-field"),
              "type": "string",
              "subtitle": "Представьтесь пожалуйста",
              "required": false
            },
            "1": {
              "field": getID("cf-field"),
              "type": "html",
              "subtitle": "Сообщите своё сообщение",
              "required": false
            } 
          },
          "style": {
            "padding": 0,
            "border": "1px solid var(--force-mini-contrast-color)"
          },
          "isOverlayButton": true,
          "overlayBg": "var(--green)",
          "overlayIconSize": 14,
          "overlayIconColor": "var(--force-plain-color)",
          "overlayBorder": {
            "borderColor": "var(--force-plain-color)",
            "borderWidth": 0,
            "borderRound" : {
                "border": 6
            }
          }, 
          "position": {
            "width": 40,
            "height": 40,
            "left": -50,
            "top": -30
          },
          "defaultTitle": "Кнопка. Контактная форма в попапе"
        }
    ]
}